import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "searchhighlight"
})
export class SearchHighLightPipe implements PipeTransform {
	transform(text?: string, search?: string): string {
		if (text === null || text === undefined) {
			return '';
		}
		const term = search?.toUpperCase() ?? '';
		const startIdx = text?.toUpperCase().indexOf(term) ?? -1;
		let html = '';
		if (term === '' || startIdx === -1) {
			if (text !== null) {
				html = '<span>' + text + '</span>';
			}
		} else {
			const tlen = term.length;

			let startTermIdx = 0;
			let endTermIdx = startIdx;
			while ((endTermIdx >= 0)) {

				html += text.substring(startTermIdx, endTermIdx) + '<span class="fw-bold">' + text.substr(endTermIdx, tlen) + '</span>';
				startTermIdx = endTermIdx + tlen;
				endTermIdx = text.toUpperCase().indexOf(term, startTermIdx)
			}

			if (startTermIdx > 0) {
				html += text.substring(startTermIdx);
			}
		}
		return html;
	}
}